import { FlowerDoodle } from "./Doodles";
import { Reveal } from "./Reveal";

const RHYTHM = [
    { time: "6:00 – 8:30 AM", activity: "Early arrivals and quiet play" },
    { time: "8:30 AM", activity: "Breakfast" },
    { time: "9:00 AM", activity: "Circle time: songs, stories, calendar" },
    { time: "9:30 AM", activity: "Learning centers & art" },
    { time: "10:30 AM", activity: "Outdoor play (daily, weather permitting)" },
    { time: "11:45 AM", activity: "Lunch" },
    { time: "12:30 PM", activity: "Rest time" },
    { time: "3:00 PM", activity: "Afternoon snack" },
    { time: "3:30 PM", activity: "Music, movement & free play" },
    { time: "5:30 – 8:00 PM", activity: "Afternoon care & pick-up" },
];

export default function DailyRhythm() {
    return (
        <div className="relative" data-testid="daily-rhythm-path">
            <div aria-hidden="true" className="absolute left-[22px] md:left-1/2 md:-translate-x-1/2 top-4 bottom-4 w-1 border-l-[3px] border-dashed border-sage/50 rounded-full" />
            <ol className="space-y-5">
                {RHYTHM.map((stop, i) => (
                    <li key={stop.time} className="relative pl-14 md:pl-0">
                        <Reveal delay={0.04 * i}>
                            <div
                                className={`md:grid md:grid-cols-2 md:gap-16 items-center ${
                                    i % 2 === 1 ? "md:[direction:rtl]" : ""
                                }`}
                            >
                                <div className={`md:text-right ${i % 2 === 1 ? "md:[direction:ltr]" : ""}`}>
                                    <span className="inline-block bg-white border-2 border-soil/10 rounded-full px-4 py-1.5 font-display font-semibold text-sageink">
                                        {stop.time}
                                    </span>
                                </div>
                                <div className={`mt-2 md:mt-0 ${i % 2 === 1 ? "md:[direction:ltr]" : ""}`}>
                                    <p className="font-bold text-lg text-soil">{stop.activity}</p>
                                </div>
                            </div>
                        </Reveal>
                        <span
                            aria-hidden="true"
                            className="absolute left-0 top-1/2 -translate-y-1/2 md:left-1/2 md:-translate-x-1/2 w-[46px] h-[46px] bg-cream border-2 border-sage/40 rounded-full flex items-center justify-center"
                        >
                            <FlowerDoodle size={26} petals={i % 3 === 0 ? "#F6C544" : i % 3 === 1 ? "#E07A5F" : "#8FB38A"} />
                        </span>
                    </li>
                ))}
            </ol>
        </div>
    );
}
